// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__2I2uU","active":"downloadDropdown_active__22Jua"};